
export default {
  data() {
    return {
      siteID: '',
      info: '',
      submitLoading: false,
      config: [
        {
          long: true,
          autoInput: true,
          prop: 'name',
          type: 'input',
          placeholder: 'Name',
        },
        {
          long: true,
          prop: 'phone',
          type: 'input',
          placeholder: 'Phone',
        },
        {
          long: true,
          prop: 'email',
          type: 'input',
          placeholder: 'Email',
        },
        {
          long: true,
          prop: 'enquiry',
          type: 'textarea',
          placeholder: 'Enquiry',
        },
      ],
      rules: {
        email: [
          {
            required: true,
            message: 'Please input',
            trigger: 'blur',
          },
        ],
        phone: [
          {
            required: true,
            message: 'Please input',
            trigger: 'blur',
          },
        ],
        name: [
          {
            required: true,
            message: 'Please input',
            trigger: 'blur',
          },
        ],
        enquiry: [
          {
            required: true,
            message: 'Please input',
            trigger: 'blur',
          },
        ],
      },
      formData: {
        // name: 'name',
        // email: 'peter@gmail.com',
        // phone: 'phone',
        // enquiry: 'enquiry',
        name: '',
        email: '',
        phone: '',
        enquiry: '',
      },
    }
  },
  async created() {
    await this.$store.dispatch('getShopInfo').then(res => {
      this.info = res.contactus
      this.siteID = res.id
    })
  },
  methods: {
    submit() {
      this.$refs.form.validate(valid => {
        if (!valid) return

        const f = JSON.parse(JSON.stringify(this.formData))
        f.site_id = this.siteID
        this.submitLoading = true
        this.$axios
          .post('/c-api/quote/sendenquiry', f)
          .then(() => {
            this.$message.success('submit success')
            this.formData = {
              name: '',
              email: '',
              phone: '',
              enquiry: '',
            }
          })
          .finally(() => {
            this.submitLoading = false
          })
      })
    },
  },
}
